import { getTextColor, setThemeColorsProperty } from '../../theme/defaultThemeOperators';
import { get } from '../../utils/get';
export const getCloseButtonColor = theme => get('closeButton', theme) || getTextColor(theme);
export const setCloseButtonColor = setThemeColorsProperty('closeButton');